(function() {
  'use strict';

  // ── Configuration ─────────────────────────────────────────────
  // IMPORTANT: Replace this with your actual Embroidery Fee variant ID
  // Get it from Admin → Products → Embroidery personalisation → click the variant → copy ID from URL
  var EMBROIDERY_VARIANT_ID = '49010477924604';

  var THREADS = [
  {name:'Gold', hex:'#C9A84C',
    filter:'brightness(0) saturate(100%) invert(68%) sepia(50%) saturate(600%) hue-rotate(5deg) brightness(95%)'},
  {name:'Silver', hex:'#A8A9AD',
    filter:'brightness(0) saturate(100%) invert(70%) sepia(5%) saturate(200%) hue-rotate(180deg) brightness(100%)'},
  {name:'Rose Gold', hex:'#C9907A',
    filter:'brightness(0) saturate(100%) invert(65%) sepia(30%) saturate(400%) hue-rotate(340deg) brightness(95%)'},
  {name:'Navy', hex:'#163055',
    filter:'brightness(0) saturate(100%) invert(14%) sepia(60%) saturate(800%) hue-rotate(195deg) brightness(80%)'},
  {name:'Black', hex:'#000000',
    filter:'brightness(0) saturate(100%) invert(95%) sepia(60%) saturate(700%) hue-rotate(290deg) brightness(90%)'},
  {name:'White', hex:'#F5F5F3', border:true,
    filter:'brightness(0) saturate(100%) invert(95%) sepia(5%) saturate(100%) brightness(110%) drop-shadow(0px 0px 2px #666) drop-shadow(0px 0px 2px #666)'},
  {name:'Forest Green', hex:'#235e59',
    filter:'brightness(0) saturate(100%) invert(25%) sepia(60%) saturate(600%) hue-rotate(150deg) brightness(70%)'},
    {name:'Purple', hex:'#54006c',
    filter:'brightness(0) saturate(100%) invert(12%) sepia(80%) saturate(1200%) hue-rotate(265deg) brightness(75%)'},
  {name:'Wine', hex:'#75051c',
    filter:'brightness(0) saturate(100%) invert(10%) sepia(80%) saturate(1200%) hue-rotate(320deg) brightness(70%)'},
  {name:'Let us choose', hex:'rainbow', border:false,
    filter:'brightness(0) opacity(0.5)'},
];

  var txt = '', font = 'gothic', threadIdx = null, openAcc = 0;

  // Load letter images from the JSON data embedded in the snippet
  var GOTHIC = null, SCRIPT = null;
  function loadLetterData() {
    var gEl = document.getElementById('emb-gothic-data');
    var sEl = document.getElementById('emb-script-data');
    if (gEl && sEl) {
      try {
        GOTHIC = JSON.parse(gEl.textContent);
        SCRIPT = JSON.parse(sEl.textContent);
      } catch(e) {
        console.error('Embroidery widget: failed to parse letter data', e);
      }
    }
  }

  function buildSamples() {
    ['gothic','script'].forEach(function(f) {
      var el = document.getElementById('emb-sample-' + f);
      if (!el) return;
      var src = f === 'gothic' ? GOTHIC : SCRIPT;
      if (!src) return;
      el.innerHTML = '';
      ['A','B','C'].forEach(function(l) {
        if (src[l]) {
          var img = document.createElement('img');
          img.src = src[l]; img.alt = l;
          el.appendChild(img);
        }
      });
    });
  }

  function buildSwatches() {
    var grid = document.getElementById('emb-swatch-grid');
    if (!grid) return;
    THREADS.forEach(function(t, i) {
      var wrap = document.createElement('div'); wrap.className = 'emb-swatch-wrap';
      var sw = document.createElement('div');
      sw.className = 'emb-swatch'; sw.id = 'emb-sw-' + i;
      sw.style.background = t.hex;
      if (t.border) sw.style.boxShadow = 'inset 0 0 0 0.5px #ccc';
      var lbl = document.createElement('div'); lbl.className = 'emb-swatch-name'; lbl.textContent = t.name;
      wrap.appendChild(sw); wrap.appendChild(lbl); grid.appendChild(wrap);
      wrap.addEventListener('click', function() { setThread(i); });
    });
  }

  function renderPreview() {
    var c = document.getElementById('emb-preview-letters');
    if (!c) return;
    var src = font === 'gothic' ? GOTHIC : SCRIPT;
    if (!src) return;
    var flt = threadIdx !== null ? THREADS[threadIdx].filter : 'brightness(0) opacity(0.65)';
    if (!txt.trim()) {
      c.innerHTML = '<span class="emb-preview-placeholder">Enter text to preview</span>';
      return;
    }
    c.innerHTML = '';
    for (var i = 0; i < txt.length; i++) {
      var ch = txt[i];
      if (ch === ' ') {
        var sp = document.createElement('div'); sp.style.width = '12px'; c.appendChild(sp);
      } else if (src[ch]) {
        var img = document.createElement('img');
        img.src = src[ch]; img.alt = ch;
        img.style.height = '36px'; img.style.width = 'auto'; img.style.display = 'block';
        img.style.filter = flt;
        c.appendChild(img);
      }
    }
  }

  function setThread(i) {
    document.querySelectorAll('.emb-swatch').forEach(function(s, j) {
      s.classList.toggle('selected', j === i);
    });
    threadIdx = i;
    var selEl = document.getElementById('emb-selected-colour');
    if (selEl) selEl.textContent = 'Selected: ' + THREADS[i].name;
    var sum2 = document.getElementById('emb-sum-2');
    if (sum2) sum2.textContent = '\u2014 ' + THREADS[i].name;
    var dot = document.getElementById('emb-thread-dot');
    if (dot) {
      dot.style.background = THREADS[i].hex;
      dot.style.boxShadow = THREADS[i].border ? 'inset 0 0 0 0.5px #ccc' : 'none';
      dot.classList.add('show');
    }
    var nm = document.getElementById('emb-thread-name-mini');
    if (nm) { nm.textContent = THREADS[i].name; nm.classList.add('show'); }
    renderPreview();
  }

  function setFont(f) {
    font = f;
    var gc = document.getElementById('emb-fc-gothic');
    var sc = document.getElementById('emb-fc-script');
    if (gc) gc.classList.toggle('selected', f === 'gothic');
    if (sc) sc.classList.toggle('selected', f === 'script');
    var sum1 = document.getElementById('emb-sum-1');
    if (sum1) sum1.textContent = f === 'gothic' ? '\u2014 Classic gothic' : '\u2014 Elegant script';
    renderPreview();
  }

  function toggleAcc(i) {
    var same = openAcc === i;
    [0,1,2].forEach(function(j) {
      var isOpen = !same && j === i;
      var body = document.getElementById('emb-body-' + j);
      var chev = document.getElementById('emb-chev-' + j);
      if (body) body.classList.toggle('open', isOpen);
      if (chev) chev.classList.toggle('open', isOpen);
    });
    openAcc = same ? null : i;
  }

  function openModal() {
    var overlay = document.getElementById('emb-overlay');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
      var inp = document.getElementById('emb-text-input');
      if (inp) inp.focus();
    }, 320);
  }

  function closeModal() {
    var overlay = document.getElementById('emb-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function addToCart() {
    if (!txt.trim()) {
      var vm = document.getElementById('emb-val-msg');
      if (vm) vm.textContent = 'Please enter your embroidery text.';
      if (openAcc !== 0) toggleAcc(0);
      return;
    }
    if (threadIdx === null) {
      toggleAcc(2);
      var selEl = document.getElementById('emb-selected-colour');
      if (selEl) selEl.textContent = 'Please select a thread colour.';
      return;
    }

    var addBtn = document.getElementById('emb-add-btn');
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    var fontName = font === 'gothic' ? 'Classic gothic' : 'Elegant script';
    var mainVariantId = document.querySelector('[name="id"]') ?
      document.querySelector('[name="id"]').value : null;

    if (!mainVariantId) {
      console.error('Embroidery widget: could not find main product variant ID');
      alert('Sorry, there was an error. Please refresh the page and try again.');
      addBtn.disabled = false;
      addBtn.textContent = 'Add to bag (+$9.99)';
      return;
    }

    var productTitle = document.querySelector('.productView-title, h1.title, h1[itemprop="name"]') ?
      document.querySelector('.productView-title, h1.title, h1[itemprop="name"]').textContent.trim() : '';

    var items = [
      {
        id: parseInt(mainVariantId),
        quantity: 1,
        properties: {
          '_embroidery_text': txt,
          '_embroidery_font': fontName,
          '_embroidery_colour': THREADS[threadIdx].name
        }
      },
      {
        id: parseInt(EMBROIDERY_VARIANT_ID),
        quantity: 1,
        properties: {
          'For': productTitle,
          'Embroidery text': txt,
          'Font style': fontName,
          'Thread colour': THREADS[threadIdx].name
        }
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        console.error('Cart error:', data.description);
        alert('Sorry, there was an error adding to cart. Please try again.');
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bag (+$9.99)';
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Add to bag (+$9.99)';
      document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      resetModal();
    })
    .catch(function(err) {
      console.error('Embroidery add to cart error:', err);
      alert('Sorry, there was an error. Please try again.');
      addBtn.disabled = false;
      addBtn.textContent = 'Add to bag (+$9.99)';
    });
  }

  function resetModal() {
    txt = '';
    var input = document.getElementById('emb-text-input');
    if (input) input.value = '';
    var cc = document.getElementById('emb-char-count');
    if (cc) { cc.textContent = '0 / 5'; cc.className = 'emb-char-count'; }
    var sum0 = document.getElementById('emb-sum-0');
    var sum1 = document.getElementById('emb-sum-1');
    var sum2 = document.getElementById('emb-sum-2');
    if (sum0) sum0.textContent = '';
    if (sum1) sum1.textContent = '';
    if (sum2) sum2.textContent = '';
    font = 'gothic';
    var gc = document.getElementById('emb-fc-gothic');
    var sc = document.getElementById('emb-fc-script');
    if (gc) gc.classList.add('selected');
    if (sc) sc.classList.remove('selected');
    threadIdx = null;
    document.querySelectorAll('.emb-swatch').forEach(function(s) { s.classList.remove('selected'); });
    var selColour = document.getElementById('emb-selected-colour');
    if (selColour) selColour.textContent = 'Select a thread colour above';
    var dot = document.getElementById('emb-thread-dot');
    if (dot) dot.classList.remove('show');
    var nm = document.getElementById('emb-thread-name-mini');
    if (nm) nm.classList.remove('show');
    var preview = document.getElementById('emb-preview-letters');
    if (preview) preview.innerHTML = '<span class="emb-preview-placeholder">Enter text to preview</span>';
    var vm = document.getElementById('emb-val-msg');
    if (vm) vm.textContent = '';
    openAcc = 0;
    [0,1,2].forEach(function(j) {
      var body = document.getElementById('emb-body-' + j);
      var chev = document.getElementById('emb-chev-' + j);
      if (body) body.classList.toggle('open', j === 0);
      if (chev) chev.classList.toggle('open', j === 0);
    });
    var overlay = document.getElementById('emb-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  // ── Wire up everything once DOM is ready ──
  function init() {
    loadLetterData();

    var trigger = document.getElementById('emb-trigger');
    if (!trigger) return; // Widget not on this page

    buildSamples();
    buildSwatches();

    trigger.addEventListener('click', openModal);

    var closeBtn = document.getElementById('emb-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    var overlay = document.getElementById('emb-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });
    }

    var textInput = document.getElementById('emb-text-input');
    if (textInput) {
      textInput.addEventListener('input', function() {
        var clean = this.value.replace(/[^a-zA-Z .]/g, '').slice(0, 5);
        var upper = clean.toUpperCase();
        if (this.value !== upper) {
          var pos = this.selectionStart;
          this.value = upper;
          try { this.setSelectionRange(pos, pos); } catch(e) {}
        }
        txt = upper;
        var len = clean.length;
        var cc = document.getElementById('emb-char-count');
        if (cc) {
          cc.textContent = len + ' / 3';
          cc.className = 'emb-char-count' + (len >= 4 ? ' warn' : '');
        }
        var sum0 = document.getElementById('emb-sum-0');
        if (sum0) sum0.textContent = txt.trim() ? '\u2014 ' + txt : '';
        var vm = document.getElementById('emb-val-msg');
        if (vm) vm.textContent = '';
        renderPreview();
      });
    }

    var gothicCard = document.getElementById('emb-fc-gothic');
    var scriptCard = document.getElementById('emb-fc-script');
    if (gothicCard) gothicCard.addEventListener('click', function() { setFont('gothic'); });
    if (scriptCard) scriptCard.addEventListener('click', function() { setFont('script'); });

    [0,1,2].forEach(function(i) {
      var btn = document.getElementById('emb-acc-btn-' + i);
      if (btn) btn.addEventListener('click', function() { toggleAcc(i); });
    });

    var addBtn = document.getElementById('emb-add-btn');
    if (addBtn) addBtn.addEventListener('click', addToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();